const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./vendors-ry3dcGwu.js","./liquid-renderer-D8R_PwPo.js"])))=>i.map(i=>d[i]);
import { _ as __vitePreload } from "./preload-helper-BbOs9S9B.js";
(async () => {
  const { Swiper, Navigation, Pagination, Autoplay, EffectFade } = await __vitePreload(async () => {
    const { Swiper: Swiper2, Navigation: Navigation2, Pagination: Pagination2, Autoplay: Autoplay2, EffectFade: EffectFade2 } = await import("./vendors-ry3dcGwu.js");
    return { Swiper: Swiper2, Navigation: Navigation2, Pagination: Pagination2, Autoplay: Autoplay2, EffectFade: EffectFade2 };
  }, true ? __vite__mapDeps([0,1]) : void 0, import.meta.url);
  class Slider extends HTMLElement {
    constructor() {
      super();
      this.checkSlider = this.checkSlider.bind(this);
      this.hideArrows = this.hideArrows.bind(this);
      this.createSliderSettings = this.createSliderSettings.bind(this);
      this.initSlider = this.initSlider.bind(this);
      this.bindSliderEvents = this.bindSliderEvents.bind(this);
      this.setSliderThemeToBody = this.setSliderThemeToBody.bind(this);
      this.launchVideoOnSlide = this.launchVideoOnSlide.bind(this);
      this.mobileBreakpoint = 1024;
      this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    }
    // Element added to page
    connectedCallback() {
      this.Slider = {};
      this.sliderEl = this.querySelector(".js-slider");
      this.slidesEls = this.sliderEl.querySelectorAll(".js-slide");
      this.isSliderMobile = this.sliderEl.classList.contains("js-slider--mobile");
      this.isSliderTablet = this.sliderEl.classList.contains("js-slider--tablet");
      this.sliderUpdateThemeStyle = this.sliderEl.classList.contains("js-slider-update-theme-style");
      this.sliderHasVideo = this.sliderEl.classList.contains("js-slider-has-video");
      this.isAutoplay = this.sliderEl.hasAttribute("data-autoplay") || false;
      this.isLoop = this.sliderEl.hasAttribute("data-loop") || false;
      this.isFade = this.sliderEl.hasAttribute("data-fade") || false;
      this.isFreeMode = this.sliderEl.hasAttribute("data-free-mode") || false;
      this.disableSlide = this.sliderEl.hasAttribute("data-disable-slide") || false;
      this.mouseWheelControl = this.sliderEl.hasAttribute("data-mousewheel") || false;
      this.isDesktopOnly = this.sliderEl.hasAttribute("data-desktop-only") || false;
      this.isMobileOnly = this.sliderEl.hasAttribute("data-mobile-only") || false;
      this.slidePerView = this.sliderEl.getAttribute("data-slide-per-view") || "auto";
      this.slideSpaceBetween = Number(this.sliderEl.getAttribute("data-space-between")) || 0;
      this.speed = parseInt(this.sliderEl.getAttribute("data-speed")) || 700;
      this.minimumLength = parseInt(this.sliderEl.getAttribute("data-minimum-length")) || 0;
      this.minimumLengthDesktop = parseInt(this.sliderEl.getAttribute("data-minimum-length-lg")) || 0;
      this.groupItems = parseInt(this.sliderEl.getAttribute("data-group-items")) || 0;
      this.loopDelay = parseInt(this.sliderEl.getAttribute("data-loop-delay")) || 3e3;
      this.direction = this.sliderEl.getAttribute("data-direction") || "horizontal";
      this.spaceBetween = Number(this.sliderEl.getAttribute("space-between")) || 0;
      this.breakpoints = JSON.parse(this.sliderEl.getAttribute("breakpoints")) || null;
      this.prevSelector = this.sliderEl.getAttribute("data-arrow-prev") || "";
      this.nextSelector = this.sliderEl.getAttribute("data-arrow-next") || "";
      this.paginationEl = this.sliderEl.getAttribute("data-pagination") || "";
      this.customPaginationEl = this.sliderEl.getAttribute("data-custom-pagination") || "";
      if (this.sliderHasVideo) {
        this.videosEls = this.sliderEl.querySelectorAll("video");
      }
      if (this.prevSelector) {
        this.prevEl = document.querySelector(this.prevSelector);
      }
      if (this.nextSelector) {
        this.nextEl = document.querySelector(this.nextSelector);
      }
      this.checkSlider();
      window.addEventListener(
        "resize",
        this.onResizeThemeUpdate = () => {
          var _a, _b;
          if (this.sliderUpdateThemeStyle && ((_b = (_a = this.Slider) == null ? void 0 : _a.slides) == null ? void 0 : _b.length) > 0) {
            const currentSlide = this.Slider.slides[this.Slider.activeIndex];
            this.setSliderThemeToBody(currentSlide);
          }
        }
      );
    }
    // element removed from page
    disconnectedCallback() {
      window.removeEventListener("resize", this.onResizeThemeUpdate);
    }
    // element moved to new page
    adoptedCallback() {
      window.lozadObserver.observe();
    }
    checkSlider() {
      if (this.isSliderMobile && !this.isMobile) {
        this.hideArrows();
        return;
      }
      if (!this.isMobile && this.slidesEls.length < this.minimumLengthDesktop) {
        this.hideArrows();
        return;
      }
      if (this.slidesEls.length < this.minimumLength) {
        this.hideArrows();
        return;
      }
      if (this.isMobile && this.isDesktopOnly) {
        this.hideArrows();
        return;
      }
      if (!this.isMobile && this.isMobileOnly) {
        this.hideArrows();
        return;
      }
      this.createSliderSettings();
    }
    createSliderSettings() {
      this.sliderSettings = {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        direction: this.direction,
        slidesPerView: this.slidePerView,
        freeMode: this.isFreeMode,
        speed: this.speed,
        loop: this.isLoop,
        loopPreventsSlide: false,
        allowTouchMove: this.disableSlide ? false : true,
        autoplay: this.isAutoplay,
        touchStartPreventDefault: false,
        lazy: {
          loadPrevNext: true
        }
      };
      if (this.slideSpaceBetween !== 0) {
        this.sliderSettings.spaceBetween = this.slideSpaceBetween;
      }
      if (this.groupItems !== 0) {
        this.sliderSettings.slidesPerView = this.groupItems;
        this.sliderSettings.slidesPerGroup = this.groupItems;
      }
      if (this.isFade) {
        this.sliderSettings.effect = "fade";
        this.sliderSettings.fadeEffect = { crossFade: true };
      }
      if (this.isAutoplay) {
        this.sliderSettings.autoplay = { delay: this.loopDelay };
      }
      if (this.spaceBetween != 0) {
        this.sliderSettings.spaceBetween = this.spaceBetween;
      }
      if (this.mouseWheelControl) {
        this.sliderSettings.mousewheel = {
          invert: false
        };
      }
      if (this.sliderEl.querySelectorAll(".swiper-wrapper .swiper-slide").length == 1) {
        this.sliderSettings.allowTouchMove = false;
        this.sliderSettings.loop = false;
      }
      if (this.prevSelector && this.nextSelector) {
        this.sliderSettings.navigation = {
          nextEl: this.nextSelector,
          prevEl: this.prevSelector,
          disabledClass: "swiper-button-disabled"
        };
      }
      if (this.paginationEl) {
        this.sliderSettings.pagination = {
          el: this.paginationEl,
          clickable: true,
          bulletClass: "slider-pagination-bullet",
          bulletActiveClass: "slider-pagination-bullet--active"
        };
      }
      if (this.isMobile) {
        this.sliderSettings.allowTouchMove = true;
      }
      if (this.breakpoints != null) {
        this.sliderSettings.breakpoints = this.breakpoints;
      }
      if (!this.isLoop) {
        this.sliderSettings.on = {
          init: () => {
            var _a;
            (_a = this.prevEl) == null ? void 0 : _a.classList.add("swiper-button-disabled");
          }
        };
      }
      if (this.sliderSettings) {
        this.initSlider();
      }
    }
    initSlider() {
      if (this.sliderEl && this.sliderSettings) this.Slider = new Swiper(this.sliderEl, this.sliderSettings);
      this.bindSliderEvents();
    }
    // bind slider events after initialiazed
    bindSliderEvents() {
      if (this.sliderUpdateThemeStyle) {
        this.setSliderThemeToBody(this.Slider.slides[this.Slider.activeIndex]);
        this.Slider.on("activeIndexChange", (swiper) => {
          this.setSliderThemeToBody(swiper.slides[swiper.activeIndex]);
        });
      }
      if (this.sliderHasVideo) {
        this.launchVideoOnSlide(this.Slider.slides[this.Slider.activeIndex]);
        this.Slider.on("activeIndexChange", (swiper) => {
          this.launchVideoOnSlide(swiper.slides[swiper.activeIndex]);
        });
      }
      if (this.customPaginationEl) {
        const customPaginationEls = document.querySelectorAll(`${this.customPaginationEl} > *`);
        if (!customPaginationEls || customPaginationEls === 1) {
          allowClick = true;
          return;
        }
        let allowClick = true;
        let currentActiveEl = customPaginationEls[0];
        this.Slider.on("activeIndexChange", (swiper) => {
          const index = swiper.slides[swiper.activeIndex].dataset.index;
          currentActiveEl.classList.remove("active");
          customPaginationEls[index].classList.add("active");
          currentActiveEl = customPaginationEls[index];
        });
        customPaginationEls.forEach((paginationEl) => {
          paginationEl.addEventListener("click", () => {
            if (allowClick) {
              allowClick = false;
              this.Slider.slideToLoop(Number(paginationEl.dataset.index), this.speed);
              currentActiveEl.classList.remove("active");
              paginationEl.classList.add("active");
              currentActiveEl = paginationEl;
              setTimeout(() => {
                allowClick = true;
              }, this.speed);
            }
          });
        });
        if (this.nextSelector) {
          this.nextEl = document.querySelector(this.nextSelector);
        }
      }
    }
    launchVideoOnSlide(slide) {
      const slideHasVideo = slide.hasAttribute("data-has-video") || false;
      if (!slideHasVideo) return;
      this.videosEls.forEach((videoEl) => {
        videoEl.pause();
        videoEl.currentTime = 0;
      });
      const currentVideosEls = slide.querySelectorAll("video");
      for (const currentVideoEl of currentVideosEls) {
        currentVideoEl.play();
      }
    }
    // set light or dark class theme to body
    setSliderThemeToBody(slide) {
      let theme = slide.dataset.itemTheme;
      if (window.innerWidth < 1023.98) {
        theme = slide.dataset.itemThemeMobile;
      }
      if (theme) {
        const themeClassPrefix = "theme-slide-";
        const availableThemes = ["light", "dark"];
        if (availableThemes.includes(theme.toLowerCase())) {
          for (let i = 0; i < availableThemes.length; i++) {
            document.body.classList.remove(themeClassPrefix + availableThemes[i]);
          }
          document.body.classList.add(themeClassPrefix + theme);
        }
      }
    }
    hideArrows() {
      var _a, _b;
      (_a = this.nextEl) == null ? void 0 : _a.classList.add("swiper-button-disabled");
      (_b = this.prevEl) == null ? void 0 : _b.classList.add("swiper-button-disabled");
    }
  }
  if (customElements.get("w3-slider") === void 0) {
    customElements.define("w3-slider", Slider);
  }
})();
